import fp from 'lodash/fp';
import React, { useMemo } from 'react';
import Draggable from 'react-draggable';

import { browserStorageAccessor, grabCursor } from '../../utils';
import { useMemoDeps } from '../../hooks';
import styles from './index.module.scss';


const DEFAULT_TOP_VALUE = 0.03;
const DEFAULT_LEFT_VALUE = 0.7;

const getPopupLocalStorage = storageKey => browserStorageAccessor(storageKey, {
    serialize: ([x, y]) => `${x / window.innerWidth}:${y / window.innerHeight}`,
    deserialize: serialized => fp.zipWith(
        fp.pipe(fp.multiply, fp.round),
        [window.innerWidth, window.innerHeight],
        serialized.split(':'),
    ),
    fallback: () => [
        fp.round(DEFAULT_LEFT_VALUE * window.innerWidth),
        fp.round(DEFAULT_TOP_VALUE * window.innerHeight),
    ],
});

export const DraggablePopup = ({ children, storageKey, buttons: Buttons }) => {
    const popupLocalStorage = useMemoDeps(getPopupLocalStorage, [storageKey]);
    const [x, y] = useMemoDeps(popupLocalStorage.get, []);
    const savePosition = useMemo(
        () => fp.debounce(100, (_, { x, y }) => popupLocalStorage.set([x, y])),
        [popupLocalStorage],
    );

    return (
        <Draggable
            bounds='html'
            defaultClassName={grabCursor}
            defaultPosition={{ x, y }}
            onStop={savePosition}
        >
            <div className={styles.popup}>
                {children}
                {Buttons && (
                    <div className={styles.buttons}>
                        <Buttons buttonClassName={styles.button} />
                    </div>
                )}
            </div>
        </Draggable>
    );
};
